import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Feature } from '@assetaccountant/api/models/feature';
import { getFeatureDisplay } from '@assetaccountant/core/models/enum/feature-display';
import { SubscriptionService } from '@assetaccountant/core/services/subscription.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-change-plan-modal',
  templateUrl: './confirm-change-plan-modal.component.html',
  standalone: false,
})
export class ConfirmChangePlanModalComponent implements OnInit {
  @Input() packageDisplayName: string;
  @Input() usedFeaturesNotInPlan: Feature[];

  @Output() confirm = new EventEmitter<void>();

  get featureText() {
    return this.usedFeaturesNotInPlan.length > 1 ? 'these features' : 'this feature';
  }

  featureIsOnlyInCustomPlan = false;
  usedFeaturesNotInPlanDisplay: string[] = [];

  constructor(
    public modal: NgbActiveModal,
    private subscriptionService: SubscriptionService,
  ) {}

  ngOnInit() {
    this.featureIsOnlyInCustomPlan = !this.subscriptionService.areFeaturesAvailableInPlans(
      this.usedFeaturesNotInPlan,
    );
    this.usedFeaturesNotInPlanDisplay = this.usedFeaturesNotInPlan.map(f => getFeatureDisplay(f));
  }

  onCancel() {
    this.modal.dismiss();
  }

  onUpdate() {
    this.confirm.emit();
    this.modal.close();
  }
}
